import { Component } from '@angular/core';

@Component({
    selector: 'app-gantt-legend',
    templateUrl: './gantt-legend.component.html',
    styleUrls: ['./gantt-legend.component.scss'],
    standalone: false
})
export class GanttLegendComponent {

  constructor() {}

}
